export const styles = {
  color: "#414141",
  fontWeight: "normal",
  marginTop: 0,
  marginBottom: 0,
};

export const styles1 = {
  text_color: {
    color: "#353535",
    fontWeight: "normal",
    marginTop: 0,
    marginBottom: 0,
    fontSize: 13,
  },
};
